export const OVERALL_CAPACITY_COLORS = {
  capacityBooked: '#005A81',
  capacityAvailable: '#87D5E4',
  noData: '#748CA0'
};

export const PLATFORMS_COLORS = {
  'Booking.com': '#E2F5F8',
  'Hotels.com': '#87D5E4',
  'Expedia.com': '#1D9DC6',
  Airnbnb: '#0E8BB4',
  TrekkSoft: '#0D7AA1',
  'Admin panel': '#005A81',
  Widget: '#5EC4DB'
};
